<template>
<span class="select-component">
<select name="category" class="types" id="categoryId" v-model="selectedCategory" data-cf-typeselect
        @change="selectCategory">
<option value="">{{ label }}</option>
<option v-for="(value, key) in options" :data-label="value" :id="'category-' + key" :key="key" :selected="preselect == key"
        :value="key">
{{ value }}
</option>
</select>
</span>
</template>

<script>
export default {
  name: "Category",
  props: {
    label: {
      type: String
    },
    preselect: {
      type: [Number, String]
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      selectedCategory: this.preselect
    };
  },
  mounted() {},
  methods: {
    selectCategory() {
      this.$emit("inputData", this.selectedCategory);
    }
  },
 beforeMount() {
    this.selectCategory(this.selectedCategory);
  }
}
</script>

<style scoped>

</style>